import React from 'react';

const WaterVapor = ({ data }) => {
  return (
    <div className="font-bold py-4">
      {data ? <h2>{data} kPa</h2> : <p className="py-4">No reading recorded</p>}
      <p>Actual Water Vapor Pressure</p>
    </div>
  );
};
export default WaterVapor;
